import React from 'react';
import SvgIcon from './SvgIcon';
import { SvgIconProps } from './types';

const TextSnippet = (props: SvgIconProps) => (
    <SvgIcon {...props} height="24px" viewBox="0 -960 960 960" width="24px">
        <g>
            <rect fill="none" />
        </g>

        <path d="M200-200h560v-367L567-760H200v560Zm0 80q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h400l240 240v400q0 33-23.5 56.5T760-120H200Zm80-160h400v-80H280v80Zm0-160h400v-80H280v80Zm0-160h280v-80H280v80Zm-80 400v-560 560Z" />
    </SvgIcon>
);

export default TextSnippet;
